module.exports = __parcel__import__.meta.resolve("k3R8T");